module.exports = __webpack_public_path__ + "img/52.442cdc60.jpg";